import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import MasterPage from '../../layouts/MasterPage';
import { Link } from 'react-router-dom';
import authAPI from '../../api/authAPI';
import AuthenticationManager from '../../services/StorageJWT';
import gameAPI from '../../api/gameAPI';
import profileAPI from '../../api/profileAPI';

const Messages = () => {
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const _auth = new AuthenticationManager();
  useEffect(() => {
    profileAPI
      .messages(_auth._token)
      .then((res) => {
        setMessages(res);
      })
      .catch((e) => {});
  }, []);

  return (
    <MasterPage>
      <div className="structure-page login p-3 body menu ">
        <div className="text-center w-100 mt-3 games">
          {messages.length>0? messages.map((msg) => (
            <div className="item mb-3">
              <svg
                className="bg-game"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 304 150"
                fill="none"
              >
                <path
                  d="M2.49609 10.7583C2.49609 6.34002 6.07782 2.7583 10.4961 2.7583H293.611C298.03 2.7583 301.611 6.34002 301.611 10.7583V139.815C301.611 144.234 298.03 147.815 293.611 147.815H10.4961C6.07782 147.815 2.49609 144.234 2.49609 139.815V10.7583Z"
                  fill="#EAE6DB"
                  stroke="#EAE6DB"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-dasharray="4 4"
                />
              </svg>
              <div className='text '>
                <p>{msg.text}</p>
                <sub className='text-end float-end'>{msg.created_at}</sub>
              </div>
            </div>
            
          )):
          <div className="item mb-3">
          <svg
            className="bg-game"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 304 150"
            fill="none"
          >
            <path
              d="M2.49609 10.7583C2.49609 6.34002 6.07782 2.7583 10.4961 2.7583H293.611C298.03 2.7583 301.611 6.34002 301.611 10.7583V139.815C301.611 144.234 298.03 147.815 293.611 147.815H10.4961C6.07782 147.815 2.49609 144.234 2.49609 139.815V10.7583Z"
              fill="#EAE6DB"
              stroke="#EAE6DB"
              stroke-width="4"
              stroke-linecap="round"
              stroke-dasharray="4 4"
            />
          </svg>
          <div className='text '>
            <p>در حال حاضر هیچ پیامی دریافت نکرده اید</p>
          
          </div>
        </div>}
          
        </div>
       

        <button
          onClick={() => window.history.back()}
          className="btn btn-return pt-2 pb-2 w-100"
        >
          بازگشت
        </button>
      
       
      </div>
    </MasterPage>
  );
};

export default Messages;
